import { CrudFilters } from "../../../../hooks/useCrudFilters";
import { useTranslation } from "react-i18next";
import { Button, Form } from "react-bootstrap";
import { LicencePlateSelectField } from "../../../general/fields/modules/commons/licencePlateSelectField/licencePlateSelectField";
import { ReactSelectOptionType } from "../../../../shared/types/reactSelectType";
import {
  TableFilterInputWrapper,
  TableFilters,
  TableFiltersWrapper,
} from "../../../general/table/modules/commons/tableFilters/tableFilters";
import { EntitySelectField } from "../../../general/fields/modules/commons/entitySelectField/entitySelectField";
import { relationSchema } from "../../../relation/domain/models/RelationModel";

export const CarTableFilters = ({
  updateFilter,
  removeFilter,
  getFilter,
  filters,
  resetFilters,
  updateFilters,
  removeFilters,
}: CrudFilters) => {
  const { t } = useTranslation("common");

  const licenceSearchValue = getFilter("licence", "in") as string[];
  const vinSearchValue = getFilter("vin", "contains") as string;
  const additionalSearchValue = getFilter(
    "additional_info",
    "contains",
  ) as string;
  const relationValue = getFilter("relation.id");

  return (
    <TableFiltersWrapper>
      <TableFilters>
        <TableFilterInputWrapper md={8}>
          <label>{t("Licence plates")}</label>
          <LicencePlateSelectField
            onChange={(options: unknown) => {
              const selectedOptions = options as ReactSelectOptionType[];

              if (options === null || selectedOptions.length === 0) {
                removeFilter("licence");
                return;
              }

              const selectedOptionsStringArray = selectedOptions.map(
                (option) => {
                  return option.label.replace(/-/g, "").toUpperCase();
                },
              );

              updateFilter("licence", selectedOptionsStringArray, "in");
            }}
            value={licenceSearchValue}
          />
        </TableFilterInputWrapper>

        <TableFilterInputWrapper md={4}>
          <label>{t("Search by car")}</label>
          <Form.Control
            type="text"
            placeholder={t("Search by car")}
            value={vinSearchValue ?? additionalSearchValue ?? ""}
            onChange={(event) => {
              const value = event.target.value;
              if (value === "") {
                removeFilters([
                  {
                    key: "vin",
                  },
                  {
                    key: "additional_info",
                  },
                  {
                    key: "licence",
                  },
                ]);
              } else {
                updateFilters([
                  {
                    key: "vin",
                    value,
                    type: "contains",
                    condition: "or",
                  },
                  {
                    key: "additional_info",
                    value,
                    type: "contains",
                    condition: "or",
                  },
                  {
                    key: "licence",
                    value: value.replace(/-/g, "").toUpperCase(),
                    type: "contains",
                    condition: "or",
                  },
                ]);
              }
            }}
          />
        </TableFilterInputWrapper>

        <TableFilterInputWrapper md={3}>
          <label>{t("Dealer")}</label>
          <EntitySelectField
            entity={"Relation"}
            prefix={"relations"}
            onChange={(option) => {
              if (option == null) {
                removeFilter("relation.id");
                return;
              }
              const { value } = option as { value: string };
              updateFilter("relation.id", value);
            }}
            limit={100}
            clearable={true}
            schema={relationSchema}
            value={relationValue}
          />
        </TableFilterInputWrapper>
      </TableFilters>

      {/* <Col md={4}>
        <Form.Group>
          <Form.Label>{t("Search by additional info")}</Form.Label>
          <Form.Control
            type="text"
            placeholder={t("Search by additional info")}
            value={additionalSearchValue ?? ""}
            onChange={(event) => {
              const value = event.target.value;
              if (value === "") {
                removeFilter("additional_info");
              } else {
                updateFilter("additional_info", value, "contains");
              }
            }}
          />
        </Form.Group>
      </Col> */}

      {filters?.fields && Object.keys(filters.fields).length > 0 && (
        <Button
          onClick={resetFilters}
          size={"sm"}
          className="reset-filters"
          variant="light"
        >
          {t("Reset filters")}
        </Button>
      )}
    </TableFiltersWrapper>
  );
};
